// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IEstimationUserChosenFiltersSchema } from '../estimation/EstimationUserChosenFiltersSchema';

export interface IEstimationSuburbanRequestSchema {
  /** Адрес **/
  address: string;
  /** Категория оценки: участок либо дом **/
  category: ECategory;
  /** Id оценки пользователя **/
  estimationId?: number;
  /** Выбранные пользователем фильтры **/
  filters?: IEstimationUserChosenFiltersSchema[];
  /** Площадь дома в квадратных метрах **/
  houseArea?: number;
  /** Площадь участка в сотках **/
  landArea: number;
  /** Координата по широте **/
  lat?: number;
  /** Координата по долготе **/
  lng?: number;
}
export enum ECategory {
  /** Загородный дом **/
  'HouseSale' = 'houseSale',
  /** Загородный участок **/
  'LandSale' = 'landSale',
}
